<template>

<div class="bar-left" v-if="!$isMobile">

	<slot></slot>

</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.bar-left {
	display: flex;
	flex-grow: 1;
	justify-content: flex-start;
}

</style>
